import React, { Component } from 'react';
import './style/MeusDados.css';
import './style/normalize.css';
import iconCard from './images/iconCard.png';
// import _15 from './images/15.png';
import close from './images/close.png';
import user from './images/user.png';
import history from './images/history.png';
import Menu from './components/menu'; 
import axios from 'axios';
import Swal from 'sweetalert2';
import Image from './components/Image.js';


class MeusDados extends Component {

    constructor(props){
        super(props);
        this.state = {
            numberFormat: this.props.location.state.numberFormat,
            number: this.props.location.state.number,
            token: this.props.location.state.token,
            showExistCard: false,
            showExistHistory: false,
            cardList: [],
            historyList: [],
            numcpf: ''
        }
    }

    getCards = () => {
        axios.post(`https://www.pagtel.com.br/AlgarCasca360/v2/GetCard`, {
            transactionId: new Date().getTime(),
            msisdn: this.state.number
        }, { headers: {"Authorization": "Bearer " + this.state.token } })
        .then(res => {
            if((res.data.code == "P00")||(res.data.code == "P01")){
                if(res.data.cardList != null){
                    this.setState({cardList: res.data.cardList});
                    this.setState({showExistCard: true});
                    this.setState({numcpf: res.data.cardList[0].cpf});
                }
                else {
                    this.setState({showExistCard: false}); 
                }
            }
            else {
                Swal.fire({
                    title: 'Erro!',
                    text: res.data.msg,
                    type: 'error'
                });
            }

        })
        .catch(res => {
            Swal.fire({
            title: 'Erro!',
            text: "Erro ao carregar os cartões!",
            type: 'error'
            })
        })
    }

    deleteCard = (paymentID) => {
        Swal.fire({
            title: 'Deletar cartão',
            text: "Deseja deletar esse cartão?",
            showCancelButton: true,
            confirmButtonText: 'Sim'
          }).then((result) => {
            if (result.value) {
                axios.post(`https://www.pagtel.com.br/AlgarCasca360/v2/deleteCard`, {
                    transactionId: new Date().getTime(),
                    msisdn: this.state.number,
                    paymentID: paymentID
                }, { headers: {"Authorization": "Bearer " + this.state.token } })
                .then(res => {
                    if(res.data.code == "P00"){
                        this.getCards();
                        Swal.fire({
                            title: 'Deletar cartão',
                            text: "Cartão deletado com sucesso",
                            type: "success"
                        })
                    }
                    else {
                        Swal.fire({
                            title: 'Erro!',
                            text: res.data.msg,
                            type: 'error'
                        });
                    }

                })
                .catch(res => {
                    Swal.fire({
                    title: 'Erro!',
                    text: "Erro ao carregar os cartões!",
                    type: 'error'
                    })
                })
            }
        })
    }

    dataAtualFormatada = () => {
        var data = new Date(),
            dia  = data.getDate().toString(),
            diaF = (dia.length == 1) ? '0'+dia : dia,
            mes  = (data.getMonth()+1).toString(), //+1 pois no getMonth Janeiro começa com zero.
            mesF = (mes.length == 1) ? '0'+mes : mes,
            anoF = data.getFullYear();
        return diaF+"/"+mesF+"/"+anoF;
    }

    getHistory = () => {
        var d = new Date();

        axios.post(`https://www.pagtel.com.br/AlgarCasca360/v2/financialHistory`, {
            transactionId: new Date().getTime(),
            msisdn: this.state.number,
            year: d.getFullYear(),
	        month: parseInt(d.getMonth() + 1)
        }, { headers: {"Authorization": "Bearer " + this.state.token } })
        .then(res => {
            if(res.data.code == "P00"){
                if(res.data.financial != null){
                    

                    const historyList = res.data.financial.filter((value, index, array) => {
                        return (value.transStatus === "P00");
                    })

                    if(historyList.length) {
                        this.setState({historyList: historyList});
                        this.setState({showExistHistory: true});
                    }
                    else {
                        this.setState({showExistHistory: false}); 
                    }
                    
                }
                else {
                    this.setState({showExistHistory: false}); 
                }
            }
            else {
                this.setState({showExistHistory: false}); 
                console.log(res.data.msg);
            }

        })
        .catch(res => {
            Swal.fire({
                title: 'Erro!',
                text: "Erro ao carregar o historico!",
                type: 'error'
            })
        })
    }

    componentDidMount() {
        this.getCards();
        this.getHistory();
    }


    render () {

        const showExistCard = this.state.showExistCard ? 'showExistCard' : '';
        const showExistHistory = this.state.showExistHistory ? 'showExistHistory' : '';


        return (
            <div className="content-recharge-all meusdados">
                <div className="content-recharge--coluns">
                    <div className="content-recharge content-recharge--1">
                        <span onClick={() => this.menuRef.openMenu()} id="menu">☰</span>
                        <img src={user} class="icon-col" alt=""/>
                        <h3>MEUS DADOS</h3>
                        <div className="group-info">
                            <p>CELULAR:</p>
                            <p>{this.state.numberFormat}</p>
                        </div>
                        <div className={`group-info showCPF ${showExistCard}`}>
                            <p>CPF:</p>
                            <p>{this.state.numcpf}</p>
                        </div>
                        <div className="group-info">
                            <p>E-MAIL:</p>
                            <input type="text" placeholder="Seu endereço de e-mail"/>
                        </div>
                        <div className="btn-salvar-dados">
                            SALVAR DADOS
                        </div>
                    </div>
                    <div className="content-recharge content-recharge--2">
                        <img src={iconCard} class="icon-col" alt=""/>
                        <h3>MEUS CARTÕES</h3>
                        <div class="content-card--list">
                            <ul className={`list-cards ${showExistCard}`}>
                                {this.state.cardList.map((item,i) => 
                                    <li key={i}>
                                        <Image type="internal" reactSRC={item.flag.toLowerCase()+".png"}/>
                                        <p>**** **** **** {item.digFour}</p>
                                        <div className="btn-delete--card">
                                            <img onClick={() => this.deleteCard(item.paymentID)} src={close} />
                                        </div>
                                    </li>
                                )}
                            </ul>
                            <ul className={`list-cards-empty ${showExistCard}`}>
                                <li>
                                    <p>Você não possui cartões</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="content-recharge content-recharge--3 historic">
                        <img src={history} class="icon-col"/>
                        <h3>PAGAMENTO</h3>
                        <table className={`list-history ${showExistHistory}`} cellspacing="0" id="gdvHistorico" >
                            <tbody>
                                <tr class="gridHeader" >
                                    <th align="center" scope="col">NÚMERO</th>
                                    <th align="center" scope="col">DATA</th>
                                    <th align="center" scope="col">VALOR</th>
                                </tr>
                                {this.state.historyList.map((item,i) =>    
                                    <tr key={i}>
                                        <td align="center">{item.msisdn.replace('55','')}</td>
                                        <td align="center">{this.dataAtualFormatada(item.transDate.split(' ')[0].replace(/-/g,'/'))}</td>
                                        <td align="center">R${item.amount}</td>
                                    </tr>
                                )}
                                
                            </tbody>
                        </table>
                        <p className={`list-history-empty ${showExistHistory}`}>NENHUM HISTÓRICO A SER EXIBIDO</p>
                    </div>
                </div>
                <Menu ref={el => this.menuRef = el} number={this.state.number} numberFormat={this.state.numberFormat} token={this.state.token}/>
            </div>
        )
    }
}

export default MeusDados;
